import { subDays, addDays } from 'date-fns';
import { dateToYmdStr } from '@lib/common';
import { deliHistory } from '@global';

export function createReturnParam(prefix = '/deals/search') {
  const location = deliHistory.location;
  return location.search
    ? `?${new URLSearchParams({
        returnTo: `${prefix}${location.search}`,
      })}`
    : '';
}
